import styled from "styled-components";

const StyledDataEntryForm = styled.form`
  font-size: 12px;
  display: flex;
  flex-direction: column;
  color: #555555;
  padding: 0 14px;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  box-sizing: border-box;
  justify-content: space-between;
  min-height: 100%;
  position: relative;

  .entry-field {
    margin-bottom: 18px;
  }

  h3 {
    font-size: 16px;
    margin: 0;
    margin-bottom: 18px;
  }

  label {
    margin-bottom: 6px;
    display: block;
  }

  input {
    display: block;
    border-radius: 20px;
    border: 1px solid #333;
    width: 100%;
    box-sizing: border-box;
    padding: 9px 13px;
  }

  .actions-container {
    text-align: center;
  }
`;

export default StyledDataEntryForm;
